module.exports = __webpack_public_path__ + "img/1.7390598e.png";